import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import CommonImage from '@components/CommonImage';
import { toastError, toastSuccess } from '@components/Toast';

import { HandoverDates } from '@features/order/components/HandoverDates';
import StyleWiseMargin from '@features/order/components/StyleWiseMargin';

import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';
import { fetchEnumFilter } from '@store/design/action';
import { fetchOrderPlaceWorkflow } from '@store/orders/actions';
import { getEnumFilter } from '@store/reducers';

import ApiClient from '@lib/apiClient';

import {
	changeDateFormat,
	convertNumberToUSFormat,
	findHeadingMaxLength,
	getShortName,
	packTag,
	parseQuoteName,
	renderMultiColor,
	renderPantoneTypeColorsVertically,
	renderSetImages,
	renderSwatchTypeColorsVertically,
	setTag,
	validateFloatNumber
} from '@utils/Util';

const StyleInfo = ({
	stylesData,
	onSetOrderStyles,
	onGetToalPrice,
	onSelectDesign,
	selectedDesigns,
	onRemoveSupplier,
	colorWiseQuantity,
	sizeWiseQuantity,
	getAllSuplierQuotes,
	orderId,
	isReadOnly,
	isMarketPlace,
	selectedDate
}) => {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);
	const [isEditFactoryEtd, setIsEditFactoryEtd] = useState(false);
	const [editFactoryEtdId, setEditFactoryEtdId] = useState(null);

	const [isEditDesign, setIsEditDesign] = useState(false);
	const [editDesignId, setEditDesignId] = useState(null);
	const [isShowBuyerPrice, setIsShowBuyerPrice] = useState('');
	const [errors, setErrors] = useState([]);
	const [, setDesignIdToView] = useState(null);
	const [designIdList, setDesignIdList] = useState([]);
	const dispatch = useDispatch();
	let allQuotation = useSelector(getEnumFilter);
	const [, setQuantityUpdate] = useState(null);
	const [editFactoryEtd, setEditFactoryEtd] = useState(null);
	const [factoryDeliveryDate, setFactoryDeliveryDate] = useState('');
	const [factoryHandoverDate, setFactoryHandoverDate] = useState('');

	useEffect(() => {
		dispatch(fetchEnumFilter('info.nitex.app.rfq.POSegmentationType')).finally(() => {
			setIsLoading(false);
		});
	}, []);

	useEffect(() => {
		if (stylesData) {
			let ids = stylesData.map((item) => item.productId);
			setDesignIdList(ids);
		}
	}, [stylesData]);

	const onCloseViewModal = () => {
		setDesignIdToView(null);
		dispatch(clearDesignViewModalInfo({}));
	};

	const onChangeQuotationType = (item, quoteIndex) => {
		const newData = [...stylesData];
		const selectedDesign = newData[quoteIndex];
		selectedDesign['factoryQuotationType'] = item.constant;
		onSetOrderStyles(newData);
	};

	const onChangePriceType = (type, quoteIndex) => {
		const newData = [...stylesData];
		const selectedDesign = newData[quoteIndex];
		selectedDesign['factoryPriceType'] = type;
		onSetOrderStyles(newData);
	};

	const onChangeColorWise = (e, quoteIndex, colorId) => {
		let { value } = e.target;
		const newData = [...stylesData];
		const orderData = newData[quoteIndex];
		orderData['colorWiseFactoryPrice'] = {
			...orderData['colorWiseFactoryPrice'],
			[colorId]: isNaN(parseFloat(value)) ? 0 : parseFloat(value)
		};
		orderData['sizeWiseFactoryPrice'] = {};
		orderData['designWiseFactoryPrice'] = null;
		newData[quoteIndex] = orderData;
		onSetOrderStyles(newData);
	};

	const onChangeSizeWise = (e, quoteIndex, sizeId) => {
		let { value } = e.target;
		const newData = [...stylesData];
		const orderData = newData[quoteIndex];
		orderData['sizeWiseFactoryPrice'] = {
			...orderData['sizeWiseFactoryPrice'],
			[sizeId]: isNaN(parseFloat(value)) ? 0 : parseFloat(value)
		};
		orderData['colorWiseFactoryPrice'] = {};
		orderData['designWiseFactoryPrice'] = null;
		newData[quoteIndex] = orderData;
		onSetOrderStyles(newData);
	};

	const onChangeDesignWise = (e, quoteIndex) => {
		let { value } = e.target;
		const newData = [...stylesData];
		const orderData = newData[quoteIndex];
		orderData['designWiseFactoryPrice'] = isNaN(parseFloat(value)) ? null : parseFloat(value);
		orderData['sizeWiseFactoryPrice'] = {};
		orderData['colorWiseFactoryPrice'] = {};
		newData[quoteIndex] = orderData;
		onSetOrderStyles(newData);
	};

	const onChangeUpdateEtd = (e, type) => {
		let { value } = e.target;
		if (type === 'factoryDeliveryDate') {
			setFactoryDeliveryDate(value);
		} else {
			setFactoryHandoverDate(value);
		}
	};

	const getSizeWisePrice = (sizeWisePrices, id) => {
		if (sizeWisePrices[id]) {
			return sizeWisePrices[id];
		}
		return null;
	};
	const getColorWisePrice = (colorWisePrices, id) => {
		if (colorWisePrices[id]) {
			return colorWisePrices[id];
		}
		return null;
	};

	const validateSizeWisePrices = (item) => {
		let givenSize = item.sizeWiseFactoryPrice;
		let availableSizes = sizeWiseQuantity[item.baseRfqId];
		let newError = [...errors];
		for (let sizeId in availableSizes) {
			if (givenSize[sizeId] === 0 && availableSizes[sizeId] !== 0) {
				newError.push(sizeId);
				setErrors([...new Set(newError)]);
			} else if (!Object.prototype.hasOwnProperty.call(givenSize, sizeId)) {
				newError.push(sizeId);
				setErrors([...new Set(newError)]);
			} else {
				let available = newError.indexOf(sizeId);
				if (available > -1) {
					newError.splice(available, 1);
				}
				setErrors([...new Set(newError)]);
			}
		}
		return newError.length === 0;
	};

	const validateColorWisePrices = (item) => {
		let givenColors = item.colorWiseFactoryPrice;
		let availableColors = colorWiseQuantity[item.baseRfqId];
		let newError = [...errors];
		for (let colorId in availableColors) {
			if (
				(givenColors[colorId] === 0 && availableColors[colorId] !== 0) ||
				!Object.prototype.hasOwnProperty.call(givenColors, colorId)
			) {
				newError.push(colorId);
				setErrors([...new Set(newError)]);
			} else {
				let available = newError.indexOf(colorId);
				if (available > -1) {
					newError.splice(available, 1);
				}
				setErrors([...new Set(newError)]);
			}
		}
		if (newError.length === 0) return true;
		return false;
	};

	const isValidPrice = (item) => {
		if (item.factoryQuotationType === 'SIZEWISE') {
			return validateSizeWisePrices(item);
		} else if (item.factoryQuotationType === 'COLORWISE') {
			return validateColorWisePrices(item);
		} else {
			if (!item.designWiseFactoryPrice) {
				setErrors([item.baseRfqId]);
				return false;
			}
			setErrors([]);
			return true;
		}
	};

	const onUpdateSuccess = () => {
		dispatch(fetchOrderPlaceWorkflow(orderId));
		setIsEditFactoryEtd(false);
		setEditFactoryEtdId(null);
		setIsEditDesign(false);
		setEditDesignId(null);
		getAllSuplierQuotes(orderId);
	};

	const onUpdateEtd = async (item) => {
		const body = {
			deliveryDate: factoryDeliveryDate || item.factoryDeliveryDate,
			factoryHandoverDate: factoryHandoverDate || item.factoryHandoverDate,
			quoteIds: [item.rfqId]
		};
		setIsLoading(true);
		await ApiClient.POST('updateEtd', body)
			.then(({ data }) => {
				setIsLoading(false);
				if (data.success) {
					toastSuccess(data.message);
					onUpdateSuccess();
					setQuantityUpdate(null);
				} else {
					toastError(data.message);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	const onUpdatePrice = async (item) => {
		let body = {};
		const isValid = isValidPrice(item);
		if (!isValid) {
			return;
		}
		body = {
			factoryQuotationType: item.factoryQuotationType,
			quoteIds: item?.etdWiseInfoList.map((edt) => edt.rfqId),
			deliveryDate: item.factoryDeliveryDate,
			priceType: item.factoryPriceType,
			factoryHandoverDate: item.factoryHandoverDate,
			extraQuantityPercentage: item.extraFactoryPercentage
		};
		if (item.factoryQuotationType === 'COLORWISE') {
			body = {
				...body,
				colorWisePrice: item.colorWiseFactoryPrice,
				sizeWisePrice: null,
				designWisePrice: null
			};
		} else if (item.factoryQuotationType === 'SIZEWISE') {
			body = {
				...body,
				sizeWisePrice: item.sizeWiseFactoryPrice,
				colorWisePrice: null,
				designWisePrice: null
			};
		} else {
			body = {
				...body,
				designWisePrice: item.designWiseFactoryPrice,
				sizeWisePrice: null,
				colorWisePrice: null
			};
		}
		setIsLoading(true);
		await ApiClient.POST('updateQuotes', body)
			.then(({ data }) => {
				setIsLoading(false);
				if (data.success) {
					toastSuccess(data.message);
					onUpdateSuccess();
				} else {
					toastError(data.message);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};
	const updateOrderQC = async (item) => {
		setIsLoading(true);
		const body = {
			isQuantityChanged: false,
			quoteIds: item?.etdWiseInfoList.map((edt) => edt.rfqId)
		};
		await ApiClient.POST('updateQuotes', body)
			.then(({ data }) => {
				setIsLoading(false);
				if (data.success) {
					toastSuccess(data.message);
					onUpdateSuccess();
					navigate(`/orders/view/${orderId}?workTab=Sales%20contract`);
					window.location.reload();
				} else {
					toastError(data.message);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	const sortBySerial = (arrayList, sizeCategorySequence) => {
		if (arrayList) {
			let modifiedArrayList = arrayList.map((item) => {
				if (sizeCategorySequence?.hasOwnProperty(item.sizeCategoryId)) {
					item.sizeCategorySerial = sizeCategorySequence[item?.sizeCategoryId];
				}
				return item;
			});
			return modifiedArrayList.slice().sort((a, b) => {
				const serialA = a.sizeCategorySerial || Number.POSITIVE_INFINITY;
				const serialB = b.sizeCategorySerial || Number.POSITIVE_INFINITY;
				if (serialA !== serialB) {
					return serialA - serialB;
				}

				// If sizeCategorySerial is the same, compare by sizeCategoryId
				if (a.sizeCategoryId !== b.sizeCategoryId) {
					return a.sizeCategoryId - b.sizeCategoryId;
				}

				// If both sizeCategorySerial and sizeCategoryId are the same, compare by order
				return a.order - b.order;
			});
		}
	};

	const renderDesignTable = (item, quoteIndex) => {
		let tableHeadingBeforSort =
			item?.colorWiseSizeQuantityPairList?.length > 0
				? item?.colorWiseSizeQuantityPairList[0]?.sizeQuantityPairList
				: item?.sizeQuantityPairList;
		let tableHeading = sortBySerial(tableHeadingBeforSort, item.sizeCategorySequenceMap);
		return (
			<div className="category-wise-table">
				{item.factoryQuotationType === 'DESIGNWISE' ? (
					<>
						<div className="designwise-price">
							{isEditDesign && editDesignId === item.baseRfqId ? (
								<input
									className={`${
										editDesignId === item.baseRfqId && errors.includes(item.baseRfqId)
											? 'border-error'
											: ''
									}`}
									type="number"
									autoComplete="off"
									min={1}
									placeholder="$00.00"
									value={item.designWiseFactoryPrice}
									onKeyPress={validateFloatNumber}
									onChange={(e) => onChangeDesignWise(e, quoteIndex)}
								/>
							) : (
								<p className="design-wise-view">
									{isMarketPlace
										? item.designWiseBuyerPrice
											? item.designWiseBuyerPrice
											: '$00.00'
										: item.designWiseFactoryPrice
											? item.designWiseFactoryPrice
											: '$00.00'}
								</p>
							)}
						</div>
						{errors.includes(item.baseRfqId) && (
							<p className="error">Factory price is required</p>
						)}
					</>
				) : item.factoryQuotationType === 'COLORWISE' ? (
					<>
						<table className="table">
							<thead>
								<tr>
									{item?.colorWiseSizeQuantityPairList &&
										item.colorWiseSizeQuantityPairList.map((value) => (
											<th key={value.id}>
												<span>{renderMultiColor(value)}</span>
											</th>
										))}
								</tr>
							</thead>
							<tbody>
								<tr>
									{item?.colorWiseSizeQuantityPairList &&
										item.colorWiseSizeQuantityPairList.map((value) => (
											<td key={value.id}>
												{isEditDesign && editDesignId === item.baseRfqId ? (
													<input
														className={`${
															editDesignId === item.baseRfqId &&
															errors.includes(value.id.toString())
																? 'border-error'
																: ''
														}`}
														type="number"
														autoComplete="off"
														min={1}
														value={getColorWisePrice(
															item?.colorWiseFactoryPrice,
															value.id
														)}
														placeholder="$00.00"
														onChange={(e) =>
															onChangeColorWise(e, quoteIndex, value.id)
														}
														onKeyPress={validateFloatNumber}
													/>
												) : (
													<p className="color-wise-view">
														{getColorWisePrice(
															isMarketPlace
																? item?.colorWiseBuyerPrice
																: item?.colorWiseFactoryPrice,
															value.id
														) || '$00.00'}
													</p>
												)}
											</td>
										))}
								</tr>
							</tbody>
						</table>
						{editDesignId === item.baseRfqId && errors.length > 0 && (
							<p className="error">Factory price is required</p>
						)}
					</>
				) : item.factoryQuotationType === 'SIZEWISE' ? (
					<>
						<table className={`table ${findHeadingMaxLength(item)}`}>
							<thead>
								<tr>
									{tableHeading.map((value) => (
										<th key={value.id}>
											<p className="semibold-14 col-heading">{value.label}</p>
										</th>
									))}
								</tr>
							</thead>
							<tbody>
								<tr>
									{item?.colorWiseSizeQuantityPairList.length > 0 &&
										item.colorWiseSizeQuantityPairList[0].sizeQuantityPairList.map(
											(value) => (
												<td key={value.id}>
													{isEditDesign && editDesignId === item.baseRfqId ? (
														<input
															className={`${
																editDesignId === item.baseRfqId &&
																errors.includes(value.id.toString())
																	? 'border-error'
																	: ''
															}`}
															type="number"
															autoComplete="off"
															min={1}
															placeholder="$00.00"
															value={getSizeWisePrice(
																item?.sizeWiseFactoryPrice,
																value.id
															)}
															onChange={(e) =>
																onChangeSizeWise(e, quoteIndex, value.id)
															}
															onKeyPress={validateFloatNumber}
														/>
													) : (
														<p className="size-wise-view">
															{getSizeWisePrice(
																isMarketPlace
																	? item?.sizeWiseBuyerPrice
																	: item?.sizeWiseFactoryPrice,
																value.id
															) || '$00.00'}
														</p>
													)}
												</td>
											)
										)}
								</tr>
							</tbody>
						</table>
						{editDesignId === item.baseRfqId && errors.length > 0 && (
							<p className="error">Factory price is required</p>
						)}
					</>
				) : (
					''
				)}
				{isEditDesign && item.baseRfqId === editDesignId ? (
					<div className="buttons d-flex ml-2 justify-content-end">
						<span
							className="regular-14 primary_bright_01 cursor-pointer"
							onClick={() => {
								onUpdatePrice(item);
							}}
							disabled={isLoading}
						>
							Update
						</span>
						<span
							className="regular-14 red ml-2 cursor-pointer"
							onClick={() => {
								setEditDesignId(null);
								setErrors([]);
								getAllSuplierQuotes(orderId);
							}}
						>
							Cancel
						</span>
					</div>
				) : (
					<>
						{!isReadOnly && (
							<div className="buttons">
								{item?.isQuantityChanged && (
									<span
										onClick={() => updateOrderQC(item)}
										className="regular-14 edit-btn primary_bright_01 cursor-pointer mr-1"
									>
										Update SC
									</span>
								)}
								{!editDesignId && (
									<span
										className="regular-14 edit-btn blue cursor-pointer"
										onClick={() => {
											setIsEditDesign(true);
											setEditDesignId(item.baseRfqId);
										}}
									>
										Edit Price
									</span>
								)}
							</div>
						)}
					</>
				)}
			</div>
		);
	};

	const getTotalQuantity = (items) => {
		return items.reduce((total, pair) => {
			if (pair.quantity) {
				return total + parseInt(pair.quantity);
			}
			return total;
		}, 0);
	};

	const getBuerPriceTypeDynamicClass = (type) => {
		if (type === 'COLORWISE') return 'colorwise-table';
		else if (type === 'SIZEWISE') return 'sizewise-table';
		else if (type === 'DESIGNWISE') return 'designwise-table';
		else return '';
	};
	const renderBuyePrice = (item) => (
		<div className="quantity-table shadow-12dp">
			<div className="quantity-heading d-flex justify-content-between">
				<h4 className="regular-14 gray_dark_02">
					Buyer price:{' '}
					<span className="gray_dark_01">
						{parseQuoteName(item.buyerQuotationType)} {item.priceType}
					</span>
				</h4>
				<img
					className="cursor-pointer"
					src={`${process.env.PUBLIC_URL}/icons/close.svg`}
					alt="close"
					onClick={() => setIsShowBuyerPrice('')}
				/>
			</div>
			<table className={`${getBuerPriceTypeDynamicClass(item.buyerQuotationType)}`}>
				<thead>
					<tr>
						<th />
						{item?.colorWiseSizeQuantityPairList.length > 0 &&
							item.colorWiseSizeQuantityPairList[0].sizeQuantityPairList.map((value) => (
								<th key={value.id}>{value.label}</th>
							))}

						<th>Qty</th>
						{item.buyerQuotationType === 'COLORWISE' && <th>Price </th>}
					</tr>
				</thead>
				<tbody>
					{item.colorWiseSizeQuantityPairList &&
						item.colorWiseSizeQuantityPairList.map((value) => (
							<tr key={value.id}>
								<td>
									{value?.representedBy === 'SWATCH'
										? renderSwatchTypeColorsVertically(value)
										: renderPantoneTypeColorsVertically(value)}
								</td>

								{value &&
									value.sizeQuantityPairList.map((style) => (
										<td key={style.id}>
											<p>{style.quantity}</p>
										</td>
									))}

								<td>
									<p>{getTotalQuantity(value.sizeQuantityPairList)}</p>
								</td>
								{item.buyerQuotationType === 'COLORWISE' && (
									<td>
										<p>${getColorWisePrice(item.colorWiseBuyerPrice, value.id)}</p>
									</td>
								)}
							</tr>
						))}

					{item.buyerQuotationType === 'SIZEWISE' && (
						<tr>
							<td></td>
							{item.colorWiseSizeQuantityPairList &&
								item.colorWiseSizeQuantityPairList[0].sizeQuantityPairList.map((style) => (
									<td key={style.id}>
										<p>
											<span>$</span>
											{getSizeWisePrice(item.sizeWiseBuyerPrice, style.id)}
										</p>
									</td>
								))}
						</tr>
					)}
				</tbody>
			</table>
			{item.buyerQuotationType === 'DESIGNWISE' && (
				<div className="unit-price text-right pr-3">
					<p className="regular-14 mb-0">
						Unit price: <span>${item.designWiseBuyerPrice}</span>
					</p>
				</div>
			)}
		</div>
	);

	const designWiseQuantityList = (design) => {
		return design.map((item) => ({
			totalQuantity: item.sizeQuantityPairList.reduce((acc, pair) => acc + pair.quantity, 0),
			id: item?.id
		}));
	};

	const sizeWiseQuantityList = (pairList) => {
		const totalQuantityMap = new Map();

		pairList.forEach((color) => {
			color.sizeQuantityPairList.forEach((size) => {
				totalQuantityMap.set(size.id, (totalQuantityMap.get(size.id) || 0) + size.quantity);
			});
		});

		return Array.from(totalQuantityMap, ([id, totalQuantity]) => ({ id, totalQuantity }));
	};

	const colorWiseQuantityList = (design) => {
		const colorWiseSizeQtyPairList = design?.colorWiseSizeQuantityPairList || [];
		return colorWiseSizeQtyPairList.map((item) => ({
			totalQuantity: item.sizeQuantityPairList.reduce((acc, pair) => acc + pair.quantity, 0),
			id: item?.id
		}));
	};

	const calculateTotalMargin = (design, factoryPriceType) => {
		const colorWiseSizeQtyPairList = design?.colorWiseSizeQuantityPairList || [];

		const colorWiseTotalAmount = [];
		const sizeWiseQtyList = sizeWiseQuantityList(colorWiseSizeQtyPairList);
		const colorWiseQtyList = colorWiseQuantityList(design);
		const designWiseQtyList = designWiseQuantityList(colorWiseSizeQtyPairList);

		const designItems =
			factoryPriceType === 'SIZEWISE'
				? sizeWiseQtyList
				: factoryPriceType === 'COLORWISE'
					? colorWiseQtyList
					: designWiseQtyList;

		designItems.forEach((item) => {
			const factoryPrice =
				factoryPriceType === 'DESIGNWISE'
					? design?.designWiseFactoryPrice
					: factoryPriceType === 'SIZEWISE'
						? design?.sizeWiseFactoryPrice[item.id]
						: factoryPriceType === 'COLORWISE'
							? design?.colorWiseFactoryPrice[item.id]
							: null;

			if (factoryPrice !== undefined) {
				colorWiseTotalAmount.push({
					id: item.id,
					totalAmount: factoryPrice * item.totalQuantity
				});
			}
		});
		return colorWiseTotalAmount.reduce((acc, item) => acc + item.totalAmount, 0);
	};

	const calculateMargin = (item) =>
		item.totalAmount - calculateTotalMargin(item, item.factoryQuotationType);

	const calculateMarginPercentage = (item) =>
		((item.totalAmount - calculateTotalMargin(item, item.factoryQuotationType)) / item.totalAmount) * 100;

	const openDesignViewModal = (item) => {
		dispatch(
			setDesignViewModalInfo({
				isShowMergeTechPack: item?.isSet,
				id: item?.productId,
				onCloseViewModal: onCloseViewModal,
				source: 'PRODUCT_LIST',
				designIdList: designIdList
			})
		);
	};

	const getAdditionalClass = (item) => {
		if (item.isQuantityChanged) return 'deactive-bg';
		else return '';
	};

	const isViewMargin = (item) => {
		if (item?.factoryQuotationType === 'DESIGNWISE') {
			return !!item.designWiseFactoryPrice;
		} else if (item?.factoryQuotationType === 'COLORWISE') {
			return item.colorWiseFactoryPrice && Object.keys(item.colorWiseFactoryPrice).length > 0;
		} else if (item?.factoryQuotationType === 'SIZEWISE') {
			return item.sizeWiseFactoryPrice && Object.keys(item.sizeWiseFactoryPrice).length > 0;
		}
		return false;
	};

	const sortByDeliveryDate = (data) => {
		return data.sort((a, b) => new Date(a.deliveryDate) - new Date(b.deliveryDate));
	};

	return (
		<div className="designs-info-section supplier-design-info-section">
			<div className="designs-row">
				{stylesData?.map((item, quoteIndex) => (
					<>
						<div
							className={`single-design scroll-x-label ${getAdditionalClass(item)}`}
							key={item.baseRfqId}
						>
							{item.isQuantityChanged && (
								<div className="error-title mb-20">
									<p className="regular-14 weight-600 gray_dark_01">
										{/* <span>
											<SupplierInfoImage width={20} className="mr-1" />
										</span> */}
										Quantity update is not yet linked to this supplier
									</p>
								</div>
							)}
							<div className="d-flex align-items-center single-design-top-content">
								<div className="">
									<div className="d-flex align-items-center">
										<div
											className="design-image"
											data-toggle="modal"
											data-target="#designViewModal"
											//onClick={() => openDesignViewModal(item)}
										>
											<div className="single-design-card with-editable">
												<div className="card-top">
													<div className="edit-items">
														<div className="select-and-edit d-flex justify-content-between">
															{!isReadOnly &&
																editDesignId !== item.baseRfqId && (
																	<div className="custom-chekbox">
																		<div className="form-group">
																			{/* {!item.supplierId ? ( */}
																			<>
																				<input
																					key={item.baseRfqId}
																					type="checkbox"
																					id={`design_${item.baseRfqId}`}
																					onChange={(e) => {
																						e.stopPropagation();
																						onSelectDesign(
																							item.baseRfqId
																						);
																					}}
																					onClick={(e) =>
																						e.stopPropagation()
																					}
																					checked={selectedDesigns.includes(
																						item.baseRfqId
																					)}
																					disabled={item.supplierId}
																				/>
																				<label
																					htmlFor={`design_${item.baseRfqId}`}
																				/>
																			</>
																		</div>
																	</div>
																)}
														</div>
													</div>
													<>
														{item?.isSet ? (
															renderSetImages(
																item?.documentResponseList,
																'108px'
															)
														) : (
															<CommonImage
																src={item?.documentResponseList[0]?.docUrl}
																alt={item.name}
																onClick={() => openDesignViewModal(item)}
																isStatic={false}
															/>
														)}
													</>
												</div>
											</div>
										</div>
										<div className="desing-all-content d-flex">
											<div className="design-details-info">
												<div className="single-design-view">
													<h3 className="gray_dark_01 weight-600 regular-14">
														{item?.isSet && setTag()} {item?.isPack && packTag()}
														{item.name}
													</h3>
													<div className="content pt-3">
														<p className="regular-14 gray_dark_02 mb-12">
															Design NO:{' '}
															<span className="gray_dark_01">
																{' '}
																{item?.referenceNumber}
															</span>
														</p>
														<p className="regular-14 gray_dark_02 mb-12">
															Margin($):{' '}
															{!isMarketPlace && isViewMargin(item) && (
																<span className="gray_dark_01">
																	{Math.sign(calculateMargin(item)) === -1
																		? '-$'
																		: '$'}
																	{convertNumberToUSFormat(
																		Math.abs(calculateMargin(item))
																	)}
																	&nbsp; (
																	{(() => {
																		const percentage =
																			calculateMarginPercentage(item);
																		return percentage == null ||
																			isNaN(percentage)
																			? 0
																			: percentage.toFixed(2);
																	})()}
																	%)
																</span>
															)}
															{isMarketPlace && (
																<StyleWiseMargin
																	defaultMargin={item?.nitexMargin || ''}
																	quoteId={item.baseRfqId}
																	getAllSupplierQuotes={() =>
																		getAllSuplierQuotes(orderId)
																	}
																/>
															)}
														</p>
													</div>
												</div>

												{isEditFactoryEtd &&
													editFactoryEtd.rfqId === editFactoryEtdId && (
														<HandoverDates
															//item={item}
															editFactoryEtd={editFactoryEtd}
															show={isEditFactoryEtd}
															onCloseHandoverDates={() => {
																setIsEditFactoryEtd(false);
																setEditFactoryEtdId(null);
																setEditFactoryEtd(null);
															}}
															onUpdateEtd={() => onUpdateEtd(editFactoryEtd)}
															onChangeUpdateEtd={(e, type) => {
																onChangeUpdateEtd(e, type);
															}}
															isLoading={isLoading}
															factoryDeliveryDate={factoryDeliveryDate}
															factoryHandoverDate={factoryHandoverDate}
														/>
													)}
											</div>
											<div className="design-details-info">
												<div className="single-design-view">
													{item.supplierName ? (
														<h3 className="gray_dark_01 weight-600 regular-14">
															<Tooltip
																title={item.supplierName}
																placement="top"
																arrow
															>
																<Link
																	to={`/suppliers/view/${item.supplierId}`}
																	target="_blank"
																>
																	{getShortName(item.supplierName, 22)}
																</Link>
															</Tooltip>
															<span
																onClick={() => onRemoveSupplier(item)}
																className="red weight-400 ml-12 cursor-pointer"
															>
																Remove
															</span>
														</h3>
													) : (
														<h3 className="gray_dark_01 weight-600 regular-14 invisible">
															Invisible
														</h3>
													)}
													<div className="content pt-3">
														<p className="regular-14 gray_dark_02 mb-12">
															Factory Value:{' '}
															{!isMarketPlace && (
																<span className="gray_dark_01">
																	$
																	{convertNumberToUSFormat(
																		onGetToalPrice(
																			item.baseRfqId,
																			item.factoryQuotationType
																		)
																	)}
																</span>
															)}
														</p>
													</div>
												</div>
											</div>
											<div className="design-details-info">
												<div className="single-design-view">
													<h3 className="gray_dark_01 weight-600 regular-14 invisible">
														Invisible
													</h3>
													<div className="content pt-3">
														<p className="regular-14 gray_dark_02">
															Quantity update:{' '}
															<span className="gray_dark_01">
																{' '}
																{item?.extraFactoryPercentage}%
															</span>
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className="order-po-details-table mt-2">
										<table className="table order-view-table no-hover border-0 shadow-none ">
											<thead>
												<tr>
													<th className="regular-14 gray_dark_02 weight-400">
														PO No
													</th>
													<th className="regular-14 gray_dark_02 weight-400">
														PO Qty
													</th>
													<th className="regular-14 gray_dark_02 weight-400">
														PO value
													</th>
													<th className="regular-14 gray_dark_02 weight-400">
														Buyer ETD
													</th>
													<th className="regular-14 gray_dark_02 weight-400">
														Handover to factory
													</th>
													<th className="regular-14 gray_dark_02 weight-400">
														Factory ETD
													</th>
												</tr>
											</thead>
											<tbody>
												{sortByDeliveryDate([...(item?.etdWiseInfoList || [])])?.map(
													(etd) => (
														<tr
															key={etd.rfqId}
															className={`${selectedDate !== etd?.deliveryDate && selectedDate !== 'All' ? 'disable disable-color' : ''}`}
														>
															<td>{etd?.poNumber}</td>
															<td>{etd?.quantity}</td>
															<td>{etd?.amount}</td>
															<td>
																{etd?.deliveryDate
																	? changeDateFormat(
																			etd?.deliveryDate,
																			'',
																			'DD MMM, YY'
																		)
																	: '--'}
															</td>
															<td>
																{etd?.factoryHandoverDate
																	? changeDateFormat(
																			etd?.factoryHandoverDate,
																			'',
																			'DD MMM, YY'
																		)
																	: '--'}
															</td>
															<td className="factory-etd-column">
																<p className="gray_dark_01 weight-500 d-flex">
																	{etd?.factoryDeliveryDate
																		? changeDateFormat(
																				etd?.factoryDeliveryDate,
																				'',
																				'DD MMM, YY'
																			)
																		: '--'}
																	<span
																		onClick={() => {
																			setIsEditFactoryEtd(true);
																			setEditFactoryEtdId(etd.rfqId);
																			setEditFactoryEtd(etd);
																			setQuantityUpdate(
																				item.extraFactoryPercentage
																					? item.extraFactoryPercentage
																					: null
																			);
																		}}
																		className="blue weight-400 ml-12 cursor-pointer"
																	>
																		Edit
																	</span>
																</p>
															</td>
														</tr>
													)
												)}
											</tbody>
										</table>
									</div>
								</div>
								<div className="design-quantity-table">
									<div className="design-info-dropdowns">
										<div className="dropdows-row d-flex justify-content-end mb-1">
											<div className="buyer-price-info">
												<p
													className="regular-14 cursor-pointer mb-0 buyer-price"
													onClick={() =>
														setIsShowBuyerPrice(
															isShowBuyerPrice ? '' : item.baseRfqId
														)
													}
												>
													Buyer price
												</p>
											</div>
											{isShowBuyerPrice === item.baseRfqId && renderBuyePrice(item)}
											<div className="option">
												{!isReadOnly ? (
													<div className="dropdown">
														<button
															className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
															type="button"
															data-toggle="dropdown"
															aria-expanded="false"
														>
															{item?.factoryQuotationType
																? parseQuoteName(item.factoryQuotationType)
																: 'Quote type'}
															<CommonImage
																src={'/icons/down-arrow.png'}
																alt="down"
																className="ml-2"
															/>
														</button>
														<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
															{allQuotation &&
																allQuotation?.quotationType?.map(
																	(item, idx) => (
																		<li
																			className="px-4 pb-3 pt-3"
																			key={idx}
																		>
																			<a
																				href={void 0}
																				className="gray_dark_02"
																				onClick={() =>
																					onChangeQuotationType(
																						item,
																						quoteIndex
																					)
																				}
																			>
																				{item.name}
																			</a>
																		</li>
																	)
																)}
														</ul>
													</div>
												) : (
													<span className="btn btn-default dropdown-toggle gray_dark_02 regular-14">
														{isMarketPlace
															? parseQuoteName(item.buyerQuotationType)
															: item?.factoryQuotationType
																? parseQuoteName(item.factoryQuotationType)
																: 'Quote type'}
													</span>
												)}
											</div>
											<div className="option">
												{!isReadOnly ? (
													<div className="dropdown">
														<button
															className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
															type="button"
															data-toggle="dropdown"
															aria-expanded="false"
														>
															{item?.factoryPriceType}

															<CommonImage
																src={'/icons/down-arrow.png'}
																alt="down"
																className="ml-2"
															/>
														</button>
														<ul className="dropdown-menu dropdown-menu-right shadow-4db">
															<li className="px-4 pb-3 pt-3">
																<a
																	href={void 0}
																	className="gray_dark_02"
																	onClick={() => {
																		onChangePriceType('CIF', quoteIndex);
																	}}
																>
																	CIF
																</a>
															</li>
															<li className="px-4 pb-3 pt-3">
																<a
																	href={void 0}
																	className="gray_dark_02"
																	onClick={() => {
																		onChangePriceType('FOB', quoteIndex);
																	}}
																>
																	FOB
																</a>
															</li>
														</ul>
													</div>
												) : (
													<span className="btn btn-default dropdown-toggle gray_dark_02 regular-14">
														{isMarketPlace
															? item.priceType
															: item?.factoryPriceType}
													</span>
												)}
											</div>
										</div>
									</div>
									<div className="design-table">{renderDesignTable(item, quoteIndex)}</div>
								</div>
							</div>
						</div>
					</>
				))}
			</div>
		</div>
	);
};

export default StyleInfo;
